<template>
  <section class="bg">

    <Header page="share" />

    <div class="main-container">

      <!-- Conversion funnel for distribution -->
      <Funnel :whatsapp_pushes="this.whatsapp_pushes" />

      <div class="bottom-container">

        <!-- List of all the phone numbers to send Whatsapp Pushes to -->
        <div class="whatsapp-pushes-loading" v-if="!is_data_fetched">
          <center>
            <a-spin>
              <a-icon slot="indicator" type="loading" style="font-size: 40px; color: #1BD285;" spin />
            </a-spin>
          </center>
        </div>

        <!-- Add Whatsapp numbers to send to -->
        <WhatsappUpload v-if="is_show_more_respondents || (is_data_fetched && this.whatsapp_pushes.length === 0)" v-on:hideAddMoreRespondents="hideAddMoreRespondents" :is_show_more_respondents="this.is_show_more_respondents" />

        <!-- Display state of Whatsapp pushes -->
        <WhatsappList v-if="!is_show_more_respondents && (is_data_fetched && this.whatsapp_pushes.length)" :whatsapp_pushes="this.whatsapp_pushes" v-on:showAddMoreRespondents="showAddMoreRespondents"/>

        <!-- QR Code, Voic.co link, M.Me link  -->
        <Links />

      </div>

    </div>

  </section>
</template>

<script>

import _ from 'lodash';
import moment from 'moment';
import { isMobile, isMobileOnly } from 'mobile-device-detect';

import Header from '@/components/Header.vue'
import Funnel from '@/components/share/Funnel.vue';
import WhatsappUpload from '@/components/share/WhatsappUpload.vue';
import WhatsappList from '@/components/share/WhatsappList.vue';
import Links from '@/components/share/Links.vue';

export default {
  name: 'share',
  components: {
    Header,
    Funnel,
    WhatsappUpload,
    WhatsappList,
    Links
  },
  data() {

    return {
      is_mobile: isMobileOnly,
      is_show_more_respondents: false
    }

  },
  computed: {

    whatsapp_pushes() {
      let survey_index = this.$route.params.survey_index;
      if (this.$store.state.surveys && this.$store.state.surveys[survey_index] && this.$store.state.surveys[survey_index].whatsapp_pushes !== null) {
        return this.$store.state.surveys[survey_index].whatsapp_pushes || [];
      } else {
        return null;
      };
    },

    is_data_fetched() {
      return this.survey ? this.$store.state.fetched_data[`${this.survey.id}-pushes`] : false;
    },

    survey() {
      let survey_index = this.$route.params.survey_index;
      let surveys = this.$store.state.surveys;
      return surveys ? surveys[survey_index] : null;
    }

  },

  methods: {

    showAddMoreRespondents() {
      this.is_show_more_respondents = true;
    },

    hideAddMoreRespondents() {
      this.is_show_more_respondents = false;
    },

  },

  mounted() {

    window.scrollTo(0, 0);

    let survey_index = this.$route.params.survey_index;
    let surveys = this.$store.state.surveys;
    let billing = this.$store.state.billing;

    if (!surveys) { // User has not yet been inited - the page was loaded directly.

      var that = this;

      setTimeout(function() {
        if (!that.$store.state.surveys) {
          that.$router.replace('/surveys'); // User hasn't authed yet, and therefore survey id's haven't been set - ideally I wait and showing loading instead of redirecting..
        } else { // See if the surveys answers have been set yet, set them if not - this will likely be called everytime
          that.$store.dispatch('setBilling');
          that.$store.dispatch('setWhatsappPushes', { survey_index });
        };
      }, 3500);

    } else {

      if (!billing) {
        this.$store.dispatch('setBilling');
      };

      this.$store.dispatch('setWhatsappPushes', { survey_index });

    };


  },

  created() {
    analytics.page('Share');
  }

};
</script>

<style lang="scss" scoped>

.bg{
  padding-bottom: 50px;
  background-image: linear-gradient(135deg, #eff0f3 1%,#fefeff 100%);
  min-height: 100%;
}

.main-container{
  width: 1080px;
  margin: 0 auto;
  margin-top: 50px;
  font-family: "Montserrat", sans-serif;
  transform: translateY(-400px);
}

.whatsapp-pushes-loading{
  width: 775px;
  padding-top: 100px;
}

.bottom-container{
  display: flex;
  align-items: flex-start;
  margin-top: 40px;
}



@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {


}

/* Ipad Portrait */
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {

}

</style>
